export default class UI {
    constructor() {
        this.init();
    }

    init() {
        this.gnav();
    }

    gnav() {
        const trigger = document.querySelector(".js-gnavtrigger");
        const gnavItem = [...document.querySelectorAll(".l-gnav__item")];

        if (trigger) {
            trigger.addEventListener("click", () => {
                document.body.classList.toggle("-gnav_active");
            });
        }

        gnavItem.forEach((el) => {
            el.addEventListener("click", () => {
                document.body.classList.remove("-gnav_active");
            });
        });
    }
}
